import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   root: {
      width: '400px',
      padding: theme.spacing(6, 4),
      marginTop: theme.spacing(4),
      boxShadow: '0px 4px 8px rgba(171, 180, 189, 0.2)',
      [theme.breakpoints.down('xs')]: {
         width: '80%',
         padding: theme.spacing(2),
      },
   },
   formControl: {
      minWidth: `100%`,
      margin: theme.spacing(1, 0, 1.4, 0),
   },
   outline: {
      '& .MuiOutlinedInput-root': {
         '& fieldset': {
            borderColor: theme.palette.primary.light,
         },
      },
      '& .MuiOutlinedInput-adornedStart': {
         paddingLeft: 0,
      },
   },
   header: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down('xs')]: {
         marginBottom: theme.spacing(3),
      },
   },
   cta: {
      fontWeight: '600',
      fontSize: '24px',
      color: 'black',
   },
   subtitle: {
      fontWeight: '400',
      color: theme.palette.text.primary,
      fontSize: '18px',
   },
   img: {
      verticalAlign: 'middle',
      borderStyle: 'none',
      [theme.breakpoints.down('md')]: {
         width: '100%',
      },
   },
}));

export { useStyles };
